import type { MessageKey } from "../types";

/** Azerbaijani copy — source: _DOCUMENTATION/az.txt (gaps filled to match RU keys). */
export const azOverrides: Partial<Record<MessageKey, string>> = {
  "nav.rating": "VPN Reytinqi",
  "nav.protocol": "Qiymətləndirmə protokolu",
  "hero.rating": "VPN Reytinqi",
  "hero.criteria": "Qiymətləndirmə meyarları",
  "hero.title": "Zvezda NA SVYAZI",
  "hero.intro":
    '<div class="font-semibold max-w-[920px] md:text-c2rem xs:text-xl pb-3 md:leading-10">Ekspertlərimiz yüzlərlə sualınızı nəzərdən keçirib və hər servisi ən sərt təhlükəsizlik meyarları ilə yoxlayıb.</div><div class="font-semibold max-w-[920px] md:text-c2rem xs:text-xl md:leading-10">NA SVYAZI ulduzunu yalnız bütün tələblərə cavab verən alətlər alır.\u00a0</div>',
  "nav.contacts": "Əlaqə",
  "search.placeholder": "VPN xidmətinin adını daxil edin",
  "main.learnMore": "Ətraflı məlumat almaq",
  "main.viewRating": "Reytinqə baxmaq",
  "region.label": "Bölgə:",
  "lang.name.ru": "Russian",
  "lang.name.en": "English",
  "lang.name.az": "Azerbaijani",
  "lang.modalTitle": "Dil",
  "rating.notFoundTitle": '"{{query}}" sorğusuna görə heç nə tapılmadı.',
  "rating.notFoundHint":
    "Servisin adını yoxlayın və yenidən cəhd edin və ya bu servisi hələ yoxlamamış ola bilərik...",
  "rating.missingService": "Öz servisinizi tapmadınız?",
  "vpn.ruBadge": "Rusiya Federasiyasına (RF) yönəldilib",
  "vpn.hide": "Gizlət",
  "vpn.more": "Ətraflı",
  "vpn.goToService": "Servisə keçid etmək",
  "vpn.promoOnButton": "artıq düymənin üzərindədir",
  "vpn.altLink": "Alternativ keçid",
  "vpn.field.starVerified": "Zvezda NA SVYAZI tərəfindən təsdiqlənib",
  "vpn.field.jurisdiction": "Yurisdiksiya",
  "vpn.field.zeroTracking": "No log / Zero tracking siyasəti",
  "vpn.field.obfuscation": "Obfuskasiya (gizlətmə / trafikin gizlədilməsi)",
  "vpn.field.cryptoPayment": "Anonim ödəniş imkanı (kriptovalyuta ilə)",
  "vpn.field.personalData": "Qeydiyyat zamanı şəxsi məlumatlar tələb edir",
  "vpn.field.support": "Texniki dəstək",
  "vpn.field.altClients": "Alternativ tətbiqlər",
  "vpn.field.splitTunneling": "Ayrı tunneleme",
  "vpn.field.protocols": "Dəstəklənən protokollar",
  "common.yes": "Bəli",
  "common.no": "Xeyr",
  "common.free": "Pulsuz",
  "common.present": "Var",
  "common.absent": "Yoxdur",
  "common.altClientsAbsent": "Yoxdur",
};
